import { motion } from "framer-motion";
import React from "react";
import { useLanguage } from "../context/LanguageContext";

const About = () => {
	const { t } = useLanguage();

	// Skill data with proficiency levels
	const skills = [
		{ name: "React", proficiency: 90 },
		{ name: "JavaScript", proficiency: 85 },
		{ name: "Node.js", proficiency: 80 },
		{ name: "Cybersecurity", proficiency: 70 },
		{ name: "UI/UX Design", proficiency: 75 },
		{ name: "Python", proficiency: 65 },
	];

	return (
		<section
			id="about"
			className="py-20 bg-white dark:bg-gray-900">
			<div className="container mx-auto px-4">
				<motion.div
					initial={{ opacity: 0, y: 20 }}
					whileInView={{ opacity: 1, y: 0 }}
					viewport={{ once: true }}
					transition={{ duration: 0.8 }}
					className="text-center mb-12">
					<h2 className="text-3xl md:text-4xl font-bold mb-4">
						{t("aboutTitle")}
					</h2>
					<div className="w-24 h-1 bg-blue-600 mx-auto mb-6"></div>
					<p className="text-lg text-gray-600 dark:text-gray-400 max-w-3xl mx-auto">
						{t("aboutSubtitle")}
					</p>
				</motion.div>

				<div className="flex flex-col lg:flex-row gap-12 items-center">
					<motion.div
						initial={{ opacity: 0, x: -30 }}
						whileInView={{ opacity: 1, x: 0 }}
						viewport={{ once: true }}
						transition={{ duration: 0.8, delay: 0.2 }}
						className="lg:w-1/2">
						<h3 className="text-2xl font-semibold mb-4 dark:text-white">
							{t("aboutWhoAmI")}
						</h3>
						<p className="text-gray-700 dark:text-gray-300 mb-4">
							{t("aboutParagraph1")}
						</p>
						<p className="text-gray-700 dark:text-gray-300 mb-4">
							{t("aboutParagraph2")}
						</p>
						<p className="text-gray-700 dark:text-gray-300">
							{t("aboutParagraph3")}
						</p>
					</motion.div>

					<motion.div
						initial={{ opacity: 0, x: 30 }}
						whileInView={{ opacity: 1, x: 0 }}
						viewport={{ once: true }}
						transition={{ duration: 0.8, delay: 0.4 }}
						className="lg:w-1/2">
						<h3 className="text-2xl font-semibold mb-6 dark:text-white">
							{t("aboutSkills")}
						</h3>
						<div className="space-y-6">
							{skills.map((skill, index) => (
								<div key={index}>
									<div className="flex justify-between mb-2">
										<span className="font-medium dark:text-white">
											{skill.name}
										</span>
										<span className="text-gray-500 dark:text-gray-400">
											{skill.proficiency}%
										</span>
									</div>
									<div className="h-3 w-full bg-gray-200 dark:bg-gray-700 rounded-full">
										<motion.div
											initial={{ width: 0 }}
											whileInView={{
												width: `${skill.proficiency}%`,
											}}
											viewport={{ once: true }}
											transition={{
												duration: 1,
												delay: 0.1 * index,
											}}
											className="h-full bg-blue-600 dark:bg-blue-500 rounded-full"></motion.div>
									</div>
								</div>
							))}
						</div>
					</motion.div>
				</div>
			</div>
		</section>
	);
};

export default About;
